"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * @Author: zzy
 * @Date: 2022-12-28 11:09:24
 * @Desc: 删除节点
 */
var _default = exports.default = {
  name: 'SFCDeleteNode'
};